
import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'
import UiChip from '@/components/UiChip.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import moment from 'moment'
import { NotificationInterface } from '@/types/interfaces'


export default Vue.extend({
  name: "Notifications",
  data(){
    return {
      emailDraft: '',
      emailTemplate: '',
      shouldShowLoadMore: false,
      isLoadingNotifications: true,
      isLoadingSubmit: false,
      numEmailsLeftForToday: 0,
      isLoadingSaveTemplate: false,
    }
  },
  computed: {
    organization(){ return this.$store.getters.organization },
    organizationUser(){ return this.$store.getters.organizationUser },
    organizationPrivate(){ return this.$store.getters.organizationPrivate },
    notifications(){ return this.$store.getters.privateNotifications },
  },
  methods: {
    async handleSaveTemplate(){
      // Confirm user really wants to store this email template:
      if(!confirm(this.$t('confirmSaveTemplate').toString())) return

      try {
        this.isLoadingSaveTemplate = true

        // Update database record
        await this.$store.dispatch('updateOrganizationPrivate', {
          emailNotificationTemplate: this.emailDraft
        })
        // Reload private Data
        await this.$store.dispatch('getOrganizationPrivate')
        // Update Template from server:
        this.loadEmailTemplateFromPrivateData()
        
      } catch (error) {
        console.error(error)
        alert(this.$t('errorSavingTemplate').toString())
      } finally {
        this.isLoadingSaveTemplate = false
      }
    },
    async handleSubmitEmail(){
      // Confirm email has text
      if(this.emailDraft.trim().length == 0) return alert(this.$t('errorEmailEmpty').toString())
      // Confirm user really wants to send this email:
      if(!confirm(this.$t('confirmEmailSend').toString())) return

      try {
        this.isLoadingSubmit = true

        // Create notification in database
        await this.$store.dispatch('createNotification', {
          body: this.emailDraft,
          senderUser: {
            id: this.organizationUser.id,
            name: this.organizationUser.name,
          }
        })
        // Reload notifications
        await this.$store.dispatch('getNotifications')
        // Update Number of emails left for today:
        this.refreshEmailsLeftCount()
        // Reset email draft
        this.emailDraft = ''

      } catch (error) {
        console.error(error)
        alert(this.$t('errorSendingEmail').toString())
      } finally {
        this.isLoadingSubmit = false
      }
    },
    handleLoadMoreNotifications: () => {}, // TODO!
    formatDate(date: Date){
      return moment(date).format("ddd, D. MMM YYYY") // TODO: Edit based on locale
    },
    refreshEmailsLeftCount(){
      const todaysNotificationsCount = this.notifications.filter((notification : NotificationInterface) => moment(notification.createdAt).isSame(new Date(), 'day')).length || 0
      this.numEmailsLeftForToday = (this.organization.static.plan.maxNotifications || 0) - todaysNotificationsCount
    },
    loadEmailTemplateFromPrivateData(){
      this.emailTemplate = this.organizationPrivate.emailNotificationTemplate
      this.emailDraft = this.emailTemplate
    }
  },
  async mounted(){
    // GET notifications from database
    await this.$store.dispatch('getNotifications')
    // Load private data for email templates
    await this.$store.dispatch('getOrganizationPrivate')
    // Update Template from private data:
    this.loadEmailTemplateFromPrivateData()
    // Update Number of emails left for today:
    this.refreshEmailsLeftCount()
    this.$data.isLoadingNotifications = false
  },
  async beforeRouteUpdate(){ // Reload when route changes without mount
    // GET notifications from database
    await this.$store.dispatch('getNotifications')
    // Update Number of emails left for today:
    this.refreshEmailsLeftCount()
    this.$data.isLoadingNotifications = false
  },
  components: {
    UiCard,
    UiButton,
    UiIcon,
    UiChip,
    AppHeader,
    AppFooter,
  },
})
